import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "../../App";

const WarrantyStatus = () => {
  const [loginId, setLoginId] = useState(null);
  const [branchCode, setBranchCode] = useState(null);

  useEffect(() => {
    const USER_ID = localStorage.getItem("USER_ID");
    const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");

    const fetchData = async () => {
      try {
        const branchRes = await axios.post(BASE_URL + "/getBranchDecode", { BRANCH_CODE });
        setBranchCode(branchRes.data.BRANCH_CODE || BRANCH_CODE);
        setLoginId(USER_ID);
      } catch (error) {
        console.error("Error in login/branch decoding:", error);
        Swal.fire("Error", "Failed to decode login or branch", "error");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (loginId && branchCode) {
      const redirectUrl = `https://mobile.cri.in/others/cridms_app/cridms_v9.3.2/validate_dms.php?usercode=${loginId}&branchcode=${branchCode}&act=warrantycheck&auth=1a223ddee21gexghhc`;

      window.open(redirectUrl, "_blank");
    }
  }, [loginId, branchCode]);

  return <div>LOADING...</div>;
};

export default WarrantyStatus;
